export default __webpack_public_path__ + "static/media/logout-img.8618034d.png";